import React, {useState} from 'react'
import { uuidv4 } from '../utils/tools';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Spinner from 'react-bootstrap/Spinner';
import { useCookies } from 'react-cookie';

const SongUploader = ({switchBack}) => {

    const [file, setFile] = useState();
    const [artist, setArtist] = useState('');
    const [title, setTitle] = useState('');
    const [artistUrl, setArtistUrl] = useState('');
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [cookies] = useCookies(['gaia-login']);
    const [loading, setLoading] = useState(false);

    async function getUploadUrl(uuid) {
        const headers = {'Authorization': 'Basic ' + btoa(cookies["gaia-login"])};
        const response = await fetch('https://csppw7sa72.execute-api.eu-north-1.amazonaws.com/default/get-upload-url?uuid=' + uuid, { headers })
        return await response.text();
    }

    const createPendingSong = (uuid) => {
        const body = {
            id: uuid,
            artist,
            title,
            artistUrl,
        };
        const options = {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Basic ' + btoa(cookies["gaia-login"]),
            },
            body: JSON.stringify(body),
        };
        return fetch("https://us-central1-voice-of-gaia.cloudfunctions.net/add-pending-song", options);
    }

    const uploadFile = () => {
        setLoading(true);
        const uuid = uuidv4();

        createPendingSong(uuid).then(() => {
            getUploadUrl(uuid).then(url => {
                console.log(url);
                const options = {
                    method: 'PUT',
                    headers: {
                      'Content-Type': 'application/octet-stream'
                    },
                    body: file,
                };
                fetch(url, options).then(result => {
                    console.log("RESULT: " + result);
                    setFileInputKey(Date.now());
                    setArtist("");
                    setTitle("");
                    setArtistUrl("");
                    setLoading(false);
                    switchBack();
                });
            });
        });
    };

    const updateFile = (e) => {
        console.log(e);
        let files = e.target.files || e.dataTransfer.files
        if (files.length) {
            setFile(files[0]);
            console.log(file);
        }
    }

    return (
        <Card style={{ width: '50%', padding: '10px'}}>
          { loading && (
              <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
              </Spinner>
              )
          }
          <Form>
          <Form.Group as={Row} controlId="file" className="mb-3">
            <Form.Label column sm="2">Music file</Form.Label>
            <Col sm="10">
              <Form.Control type="file" key={fileInputKey} onChange={updateFile}/>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="artist">
            <Form.Label column sm="2">Artist</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={artist}  onChange={(e) => {setArtist(e.target.value)}} name="artist"/>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="title">
            <Form.Label column sm="2">Title</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={title}  onChange={(e) => {setTitle(e.target.value)}} name="title"/>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="artistUrl">
            <Form.Label column sm="2">Website</Form.Label>
            <Col sm="10">
                <Form.Control type="text" value={artistUrl}  onChange={(e) => {setArtistUrl(e.target.value)}} name="artistUrl"/>
            </Col>
          </Form.Group>
          <Button variant="primary" onClick={uploadFile}>Upload!</Button>
          </Form>
        </Card>
    )
}

export default SongUploader
